import {
  GraphQLID,
  GraphQLFieldConfig,
  GraphQLNonNull,
  GraphQLInputObjectType
} from 'graphql'
import { Context } from '../shared'
import {
  GenericMutationResponseType,
  GenericMutationResponse
} from '../types/generic-mutation-response'
import {
  VulnerabilityPolicyInput,
  vulnerabilityPolicyInput
} from '../types/vulnerability-policy'

interface UpdateVulnerabilityPolicyArgs {
  readonly input: {
    readonly organizationID: string
    readonly policy: Partial<VulnerabilityPolicyInput>
    readonly id: number
  }
}

export const updateVulnerabilityPolicyType = new GraphQLInputObjectType({
  name: 'UpdateVulnerabilityPolicyType',
  description:
    'Parameters that describe a update vulnerability policy operation',
  fields: () => ({
    id: {
      description: 'The policy unique ID ',
      type: new GraphQLNonNull(GraphQLID)
    },
    organizationID: {
      description:
        'The ID of the organization that the vulnerabilty policy belongs to',
      type: new GraphQLNonNull(GraphQLID)
    },
    policy: {
      description: 'The vulnerability policy object',
      type: new GraphQLNonNull(vulnerabilityPolicyInput)
    }
  })
})

export const updateVulnerabilityPolicyArgs = {
  input: {
    type: updateVulnerabilityPolicyType
  }
}

export const updateVulnerabilityPolicy: GraphQLFieldConfig<
  any,
  Context,
  UpdateVulnerabilityPolicyArgs
> = {
  description: 'Update vulnerability policy',
  type: new GraphQLNonNull(GenericMutationResponseType),
  args: updateVulnerabilityPolicyArgs,
  resolve: async (_source, args, context): Promise<GenericMutationResponse> => {
    const {
      input: {
        id,
        organizationID,
        policy: {
          name,
          remediationDays,
          allApplications,
          applicationImportance,
          applications = [],
          allRules,
          ruleSeverities = [],
          rules = [],
          allServerEnvironments,
          serverEnvironments = [],
          routeBasedEnabled,
          action,
          autoVerificationType
        }
      }
    } = args

    await context.connector.put(`${organizationID}/policy/remediation/${id}`, {
      name,
      remediation_days: remediationDays,
      all_applications: allApplications,
      application_importance: applicationImportance,
      applications,
      all_rules: allRules,
      rule_severities: ruleSeverities,
      rules,
      all_server_environments: allServerEnvironments,
      server_environments: serverEnvironments,
      route_based_enabled: routeBasedEnabled,
      action,
      auto_verification_type: autoVerificationType
    })

    return { _placeholder: true }
  }
}
